var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.5h4v1h-4zm5-2h-5v1h5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 1.25A1.75 1.75 0 0 0 2.25 3v10c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 13.75 13V6.414c0-.464-.184-.909-.513-1.237L9.823 1.763a1.75 1.75 0 0 0-1.237-.513zM3.75 3A.25.25 0 0 1 4 2.75h4.5V6.5h3.75V13a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25zm7.69 2.5L9.5 3.56V5.5z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export default ForwardRef;